import './Login.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logger from '@KrashidBuilt/common/utils/logger';
import { ROUTE_MAP } from '../../routes';
import { getAccessToken, getUser } from '../../api/credentials';
import { UserContext } from '../../ctx';
import { SignInForm } from '@fifth-gear-tech/common-components/dist/components';


const logger = new Logger('Login');

const getLocalLogin = () => {
    try {
        const found = JSON.parse(localStorage.getItem('LOGIN'));
        if (found) {
            return found;
        }
    } catch (error) { }
    return {};
};

/**
 * Login Component
 * @augments {Component<Props, State>}
 */
class Login extends Component {

    constructor(props) {
        super(props);

        const { companyId = '', username = '' } = getLocalLogin();

        this.state = {
            working: false,
            selectableCompanies: [],
            companyId,
            username,
            password: '',
            error: null,
        };
    }

    loginSuccess = () => {

        // check for redirect
        // eslint-disable-next-line react/prop-types
        const { location: { search } } = this.props;
        const searchParams = new URLSearchParams(search);
        const jobId = searchParams.get('jobId');

        this.context.setUser(getUser(), () => {
            this.props.history.replace(`${jobId ? `${ROUTE_MAP.LABELS}/${jobId}` : ROUTE_MAP.LABELS}`);
        });
    };

    componentDidMount() {
        const { working } = this.state;
        if (!working) {
            this.setState({ working: true }, async () => {
                try {
                    const token = await getAccessToken();
                    if (token) {
                        this.loginSuccess();
                    }
                } catch (error) { }
                this.setState({ working: false });
            });
        }
    }

    render() {
        logger.extra({ _: this });
        return (
            <div className={'Login'}>
                <div className={'LoginForm'}>
                    <SignInForm
                        // POST request happens in library 👇
                        // creds is added to local stage in library as well
                        onLoginSuccess={() => {
                            this.setState({ working: false, token: JSON.parse(localStorage.getItem('creds')) }, this.loginSuccess);
                        }}
                    />
                </div>
            </div>
        );
    }
}

Login.contextType = UserContext;

Login.defaultProps = {
};

Login.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.shape(),
};


export default Login;